import { useContext } from "react";
import UIContext from "../context/UIProvider";

const useUIContext = () => {
  return useContext(UIContext);
};

export default useUIContext;
